import classNames from 'classnames';
import { FC } from 'react';

import { MultiLineField as BaseMultiLineField } from '@gem/ui-kit';

import styles from './MultiLineField.styles.m.css';
import { IMultiLineFieldProps } from './MultiLineField.types';
import { MultiLineFieldHelperText } from './MultiLineFieldHelperText/MultiLineFieldHelperText';

export const MultiLineField: FC<IMultiLineFieldProps> = (props) => {
  const {
    className,
    input: { name, onChange, value, onFocus, onBlur },
    meta: { active, error, invalid, modified, validating },
    label,
    placeholder,
    maxLength,
    isDisabled = false,
    helperText,
    setRef,
    autoFocus,
    isDynamicHeight = false,
  } = props;

  const hasError = !validating && !!modified && !!invalid && Boolean(error?.trim());

  return (
    <BaseMultiLineField
      className={classNames(styles.container, className)}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      active={active}
      value={value}
      label={label}
      placeholder={placeholder}
      maxLength={maxLength}
      hasError={hasError}
      ref={setRef}
      autoFocus={autoFocus}
      isDisabled={isDisabled}
      isDynamicHeight={isDynamicHeight}
    >
      <MultiLineFieldHelperText
        hasError={hasError}
        errorText={error}
        helperText={helperText}
      />
    </BaseMultiLineField>
  );
};
